import HeroBanner from './HeroBanner'
import FeaturedProducts from './FeaturedProducts'
import LatestNews from './LatestNews'
import QuickLinks from './QuickLinks'

const Home = () => {
  return (
    <div className="space-y-1">
      <HeroBanner />
      <FeaturedProducts />
      <LatestNews />
      {/* <QuickLinks /> */}
    </div>
  )
}

export default Home 